module.exports = __webpack_public_path__ + "img/notify-check.99c9d1ad.svg";